export const MAX_POINTS_FOR_RATINGS = 5;
export const MIN_POINTS_FOR_RATINGS = 1;
export const EXPONDO_REVIEW_SOURCE = 'expondo';
